module.exports = __webpack_public_path__ + "img/bank-krungsri-02.e955e4a6.png";